import { render, staticRenderFns } from "./import-logs.vue?vue&type=template&id=56157d8e"
import script from "./import-logs.vue?vue&type=script&lang=js"
export * from "./import-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports